<template>
  <settings-screen title="About">
    <div class="content">
      <litera-logo class="logo"/>
      <h2>Litera</h2>
      <span>version {{ version }}</span>
      <a
          class="github-link"
          href="https://github.com/flavioosh/litera"
          target="_blank"
          title="GitHub">
        <github-logo
            viewBox="0 0 16 16"
            width="32"
            height="32"/>
      </a>
    </div>
  </settings-screen>
</template>

<script>
import SettingsScreen from '@/components/settings/SettingsScreen.vue';

import LiteraLogo from '@/assets/logo.svg';
import GithubLogo from '@/assets/github-logo.svg';

export default {
  name: 'AboutModal',
  components: {
    LiteraLogo,
    GithubLogo,
    SettingsScreen,
  },
  data() {
    return {
      version: litera.version,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.content {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  .logo {
    height: 12rem;
    margin-bottom: 1.5rem;
    width: 12rem;
  }

  .github-link {
    margin: 1rem;

    svg {
      fill: $text;
      transition: fill .2s;
    }

    &:hover {
      svg {
        fill: $text-hover;
      }
    }

    &:active {
      svg {
        fill: $text-active;
      }
    }
  }
}
</style>
